import API_END_POINTS from "../../utilities/Constants/ApiEndpoints";
import { baseApi } from "./baseQuery";

const dashboardPageApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    dashboardGeneratedModelList: build.query({
      query: (values) => ({
        url: API_END_POINTS.MODELS_LIST + `?listType=${values.listType}&list_type=${values.activeFilter}&search=${values?.search}&page=${values?.page}&limit=${values?.limit}`,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    dashboardDraftModelList: build.query({
      query: (values) => ({
        url: API_END_POINTS.VIEWPORT_DRAFT_MODELS_LIST + `?format_type=${values.format_type}&list_type=${values.activeFilter}&search=${values?.search}&page=${values?.page}&limit=${values?.limit}`,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    featureStatus: build.mutation({
      query: (values) => ({
        url: API_END_POINTS.FEATURE_STATUS,
        method: "POST",
        body: values
      }),
      invalidatesTags: ["dashboard"]
    }),
    linkUpload: build.mutation({
      query: (values) => ({
        url: `${API_END_POINTS.WEBLINK_MODEL}?weblink=${values.weblink}`,
        method: "POST",
        body: {}
      }),
      invalidatesTags: ["dashboard"]
    }),
    fileUpload: build.mutation({
      query: (values) => ({
        url: `${API_END_POINTS.UPLOAD_MODEL}`,
        method: "POST",
        body: values
      }),
      invalidatesTags: ["dashboard"]
    }),
    dashboardSearchModel: build.query({
      query: (payload) => ({
        url: API_END_POINTS.DASHBOARD_GENERAL_SEARCH + `?search=${payload?.search}&format_type=${payload?.format_type}`,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    deleteModelLists: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS?.DELETE_MODEL_LIST,
        method: "DELETE",
        body: payload
      }),
      invalidatesTags: ["dashboard"]
    }),
    adminProfileEdit: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS?.ADMIN_PROFILE,
        method: "POST",
        body: payload
      }),
      invalidatesTags: ["dashboard"]
    }),
    fileUploads: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS?.FILE_UPLOAD,
        method: "POST",
        body: payload
      }),
      invalidatesTags: ["dashboard"]
    }),
    getAdminProfile: build.query({
      query: (values) => ({
        url: API_END_POINTS.GET_ADMIN_PROFILE,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    createConnection: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS?.CREATE_CONNECTION,
        method: "POST",
        body: payload
      }),
      invalidatesTags: ["dashboard"]
    }),
    getRedirectionURL: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS?.GET_CHAT_REDIRECT_LINK + `?key=${payload?.key}`,
        method: "POST",
      }),
      invalidatesTags: ["dashboard"]
    }),
    getChatHistory: build.query({
      query: (values) => ({
        url: API_END_POINTS.CHAT_HISTORY,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    getStaffListOnboard: build.query({
      query: () => ({
        url: API_END_POINTS.STAFF_LIST,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    getUserPrivilege: build.query({
      query: () => ({
        url: API_END_POINTS.GET_PRIVILAGE_LIST,
        method: "GET",
      }),
      providesTags: ["dashboard"]
    }),
    onboardingStaffs: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS.ONBOARD_STAFFS,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["dashboard"]
    }),
    updateStaffsPrivilege: build.mutation({
      query: (payload) => ({
        url: API_END_POINTS.UPDATE_STAFFS_PRIVILEGE,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["dashboard"]
    }),

  }),
  // @ts-ignore
  overrideExisting: module.hot?.status() === "apply",
});

export const {
  useLazyDashboardGeneratedModelListQuery,
  useLazyDashboardDraftModelListQuery,
  useFeatureStatusMutation,
  useLinkUploadMutation,
  useFileUploadMutation,
  useDashboardSearchModelQuery,
  useDeleteModelListsMutation,
  useAdminProfileEditMutation,
  useFileUploadsMutation,
  useGetAdminProfileQuery,
  useCreateConnectionMutation,
  useGetRedirectionURLMutation,
  useGetChatHistoryQuery,
  useGetStaffListOnboardQuery,
  useGetUserPrivilegeQuery,
  useOnboardingStaffsMutation,
  useUpdateStaffsPrivilegeMutation,
} = dashboardPageApi;
